<div
  class="app"
  [class.container]="!isMap && !isDashboard && !isRegistrationRequest && !isEPContainer"
  [class.container-dashboard]="isDashboard"
  [class.container-24]="isEPContainer"
>
  <div
    class="indicator"
    *ngIf="environment === 'development' || environment === 'staging'"
    [ngClass]="{
      'indicator-color-dev': environment === 'development',
      'indicator-color-qa': environment === 'staging'
    }"
  >
    <p>{{ indicator }}</p>
  </div>
  <router-outlet></router-outlet>
</div>
<app-overlay-loader *ngIf="isLoading"></app-overlay-loader>
